<template>
  <v-row justify="center">
    <v-dialog v-model="openDialog" persistent max-width="800px">
      <v-card>
        <v-form ref="form" v-model="valid">
          <v-card-title class="mx-3 pl-6 pt-4">
            <span v-if="selectedBooking.id" class="text-h5"
              >Buchung bearbeiten</span
            >
            <span v-else class="text-h5">Neue Buchung anlegen</span>
          </v-card-title>
          <v-divider class="mx-9" />
          <v-card-text>
            <v-container>
              <v-row class="mt-5">
                <v-col>
                  <v-text-field
                    bg-color="accent"
                    variant="filled"
                    hide-details
                    label="ID"
                    readonly
                    disabled
                    v-model="selectedBooking.id"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    bg-color="accent"
                    variant="filled"
                    hide-details
                    label="Mandant"
                    v-model="selectedBooking.tenantId"
                    readonly
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-if="selectedBooking._populated && workflow.active">
                  <v-select
                    :items="[
                      ...workflow.states,
                      { name: 'Archive', id: 'archive' },
                    ]"
                    v-model="selectedBooking._populated.workflowStatus"
                    variant="underlined"
                    label="Workflow Status"
                    item-title="name"
                    item-value="id"
                  >
                    <template #selection="{ item }">
                      <v-chip size="small" variant="flat" color="secondary">{{
                        item.name
                      }}</v-chip>
                    </template>
                  </v-select>
                </v-col>
                <v-col>
                  <v-checkbox
                    label="Ist bezahlt"
                    v-model="selectedBooking.isPayed"
                    color="primary"
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    label="Ist freigegeben"
                    v-model="selectedBooking.isCommitted"
                    color="primary"
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    label="Ist storniert"
                    v-model="selectedBooking.isRejected"
                    color="error"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :items="activePaymentApps"
                    v-model="selectedBooking.paymentProvider"
                    variant="underlined"
                    label="Zahlungsmethode"
                    item-title="title"
                    item-value="id"
                  >
                  </v-select>
                </v-col>
                <v-col>
                  <v-select
                    :items="paymentMethod"
                    v-model="selectedBooking.paymentMethod"
                    variant="underlined"
                    label="Bezahlt mit"
                    item-title="title"
                    item-value="type"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-if="!!selectedBooking.couponCode"
                    bg-color="accent"
                    variant="filled"
                    hide-details
                    label="genutzter Gutschein"
                    v-model="selectedBooking._couponUsed.id"
                    readonly
                    disabled
                    :placeholder="selectedBooking._couponUsed.id"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-if="!!selectedBooking.couponCode"
                    bg-color="accent"
                    variant="filled"
                    hide-details
                    label="Rabatt"
                    v-model.number="selectedBooking._couponUsed.discount"
                    readonly
                    disabled
                    :placeholder="selectedBooking._couponUsed.discount"
                    :suffix="
                      selectedBooking._couponUsed.type === 'percentage'
                        ? '%'
                        : '€'
                    "
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <p class="text-uppercase">
                    <strong>Gebuchte Objekte</strong>
                  </p>
                </v-col>
              </v-row>

              <v-divider class="" />
              <v-list>
                <v-list-item
                  v-for="bookableItem in bookableItems"
                  :key="bookableItem.id"
                >
                  <v-list-item-title class="d-flex">
                    <v-row class="align-center">
                      <v-col cols="auto">
                        {{ bookableItem._bookableUsed.title }}
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="4">
                        <v-text-field
                          :model-value="
                            getPriceCategory(
                              bookableItem.bookableId,
                              'priceEur'
                            )
                          "
                          @update:model-value="
                            updatePriceCategory(bookableItem.bookableId, $event)
                          "
                          variant="filled"
                          prefix="€"
                          bg-color="accent"
                          hide-details
                          :suffix="
                            isTimeRelated(
                              bookableItem._bookableUsed,
                              getPriceCategory(
                                bookableItem.bookableId,
                                'fixedPrice'
                              )
                            )
                          "
                          label="Preis (netto)"
                          type="number"
                          :rules="validationRules.priceRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4" class="d-flex align-center">
                        <v-tooltip
                          location="top"
                          max-width="300"
                          open-delay="400"
                        >
                          <template v-slot:activator="{ props }">
                            <div v-bind="props">
                              <v-checkbox
                                class="d-flex align-center"
                                density="compact"
                                :model-value="
                                  getPriceCategory(
                                    bookableItem.bookableId,
                                    'fixedPrice'
                                  )
                                "
                                @update:model-value="
                                  updateFixedPrice(
                                    bookableItem.bookableId,
                                    $event
                                  )
                                "
                                label="Pauschalpreis"
                              >
                              </v-checkbox>
                            </div>
                          </template>
                          <span>
                            Bei Aktivierung wird immer der Grundpreis berechnet.
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="auto">
                        <div class="d-flex">
                          <v-btn
                            icon
                            variant="text"
                            size="x-small"
                            @click="decreaseAmount(bookableItem)"
                          >
                            <v-icon>mdi-minus</v-icon>
                          </v-btn>
                          <div class="px-1 mt-2">{{ bookableItem.amount }}</div>
                          <v-btn
                            icon
                            variant="text"
                            size="x-small"
                            @click="increaseAmount(bookableItem)"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
              <div
                v-if="selectedBooking.bookableItems?.length === 0"
                class="text-center font-italic"
              >
                Diese Buchung enthält keine Buchungen
              </div>
              <v-autocomplete
                placeholder="Ein weiteres Element Hinzufügen"
                v-model="addBookableValue"
                :items="bookables"
                variant="underlined"
                item-value="id"
                item-title="title"
                validate-on="blur"
                :rules="
                  bookableItems.length === 0
                    ? validationRules.bookableItemRequired
                    : []
                "
                ref="bookableAutocomplete"
              >
                <template v-slot:append>
                  <v-btn
                    size="small"
                    color="primary"
                    :disabled="!addBookableValue"
                    @click="addBookable"
                  >
                    <v-icon start> mdi-plus</v-icon>
                    Hinzufügen
                  </v-btn>
                </template>
              </v-autocomplete>

              <v-row class="mt-5 d-flex align-center">
                <v-col>
                  <p class="text-uppercase">
                    <strong>Buchungszeitraum</strong>
                  </p>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    size="small"
                    variant="outlined"
                    @click="removeBookingTimes"
                    >Buchungszeitraum löschen</v-btn
                  >
                </v-col>
              </v-row>
              <v-divider class="mb-5 mt-2" />
              <v-row no-gutters>
                <v-col cols="12">
                  <p class="text-uppercase">
                    <strong>Beginn</strong>
                  </p>
                </v-col>
                <v-col class="mr-5 mt-3">
                  <v-dialog
                    ref="dateFromDialog"
                    v-model="dateFromModal"
                    persistent
                    width="290"
                  >
                    <template #activator="{ props }">
                      <v-text-field
                        v-model="dateFrom"
                        label="Datum"
                        prepend-icon="mdi-calendar"
                        bg-color="accent"
                        variant="filled"
                        readonly
                        v-bind="props"
                        @click:prepend-icon="dateFromModal = true"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      v-model="dateFrom"
                      scrollable
                      hide-title
                      :first-day-of-week="1"
                    >
                      <template #actions>
                        <v-spacer />
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="
                            dateFrom = dateFromTemp;
                            dateFromModal = false;
                          "
                        >
                          Abbrechen
                        </v-btn>
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="dateFromModal = false"
                        >
                          Speichern
                        </v-btn>
                      </template>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col class="mt-3">
                  <v-dialog
                    ref="timeFromDialog"
                    v-model="timeFromModal"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        v-model="timeFrom"
                        label="Uhrzeit"
                        prepend-icon="mdi-clock-time-four-outline"
                        bg-color="accent"
                        variant="filled"
                        readonly
                        v-bind="props"
                        @click:prepend-icon="timeFromModal = true"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="timeFrom"
                      v-model="timeFrom"
                      full-width
                      format="24hr"
                    >
                      <template #actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="
                            timeFrom = timeFromTemp;
                            timeFromModal = false;
                          "
                        >
                          Abbrechen
                        </v-btn>
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="timeFromModal = false"
                        >
                          Speichern
                        </v-btn>
                      </template>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <p class="text-uppercase">
                    <strong>Ende</strong>
                  </p>
                </v-col>
                <v-col class="mr-5 mt-3">
                  <v-dialog
                    ref="dateToDialog"
                    v-model="dateToModal"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        v-model="dateTo"
                        label="Datum"
                        prepend-icon="mdi-calendar"
                        bg-color="accent"
                        variant="filled"
                        readonly
                        v-bind="props"
                        @click:prepend-icon="dateToModal = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateTo"
                      hide-title
                      scrollable
                      :first-day-of-week="1"
                    >
                      <template #actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="
                            dateTo = dateToTemp;
                            dateToModal = false;
                          "
                        >
                          Abbrechen
                        </v-btn>
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="dateToModal = false"
                        >
                          Speichern
                        </v-btn>
                      </template>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col class="mt-3">
                  <v-dialog
                    ref="timeToDialog"
                    v-model="timeToModal"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        v-model="timeTo"
                        label="Uhrzeit"
                        prepend-icon="mdi-clock-time-four-outline"
                        bg-color="accent"
                        variant="filled"
                        readonly
                        v-bind="props"
                        @click:prepend-icon="timeToModal = true"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="timeTo"
                      v-model="timeTo"
                      full-width
                      format="24hr"
                    >
                      <template #actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="
                            timeTo = timeToTemp;
                            timeToModal = false;
                          "
                        >
                          Abbrechen
                        </v-btn>
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="timeToModal = false"
                        >
                          Speichern
                        </v-btn>
                      </template>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <template
                v-if="allowRecurringBookingsCreation && !selectedBooking.id"
              >
                <v-row no-gutters>
                  <v-row class="ml-0 ms-1 mt-1 pa-0 d-flex align-center">
                    <v-checkbox
                      density="comfortable"
                      v-model="allowRecurringBookings"
                      hide-details
                      class="ma-0 pa-0"
                    />
                    <span> Wiederkehrende Buchung erstellen</span>
                  </v-row>
                </v-row>
                <template v-if="allowRecurringBookings">
                  <v-row class="mt-4">
                    <v-col>
                      <p class="text-uppercase">
                        <strong>Wiederholungsmuster</strong>
                      </p>
                    </v-col>
                  </v-row>
                  <v-divider class="mb-5" />
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="recurringBooking.repeatEvery"
                        label="Wiederholt jeden"
                        type="number"
                        hide-details
                        bg-color="accent"
                        variant="filled"
                        :rules="validationRules.required"
                      />
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="recurringBooking.repeatUnit"
                        label="Typ"
                        :items="repeatUnitTypes"
                        hide-details
                        bg-color="accent"
                        variant="filled"
                        :rules="validationRules.required"
                      />
                    </v-col>
                  </v-row>
                  <v-row v-if="recurringBooking.repeatUnit === 'week'">
                    <v-row
                      class="ms-1 mt-3 mb-3 ml-2 justify-center"
                      style="display: flex; gap: 16px"
                    >
                      <v-btn
                        v-for="(day, i) in days"
                        :key="day"
                        class="day-btn"
                        :class="{
                          'selected-day':
                            recurringBooking.repeatOnWeekdays.includes(i),
                          'text-black':
                            !recurringBooking.repeatOnWeekdays.includes(i),
                        }"
                        :variant="
                          recurringBooking.repeatOnWeekdays.includes(i)
                            ? 'flat'
                            : 'outlined'
                        "
                        @click="toggleDay(i)"
                      >
                        {{ day }}
                      </v-btn>
                    </v-row>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="6"
                      v-if="recurringBooking.repeatUnit === 'month'"
                    >
                      <v-select
                        v-model="recurringBooking.monthRepeatBy"
                        :items="monthlyRepeatOptions"
                        label="Wiederholungsart"
                        bg-color="accent"
                        variant="filled"
                        hide-details
                        :rules="validationRules.required"
                      />
                    </v-col>
                    <v-col
                      :cols="recurringBooking.repeatUnit === 'month' ? 6 : 12"
                    >
                      <v-dialog
                        ref="dateToDialog"
                        v-model="repeatUntilMenu"
                        :return-value.sync="recurringBooking.repeatUntil"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ props }">
                          <v-text-field
                            v-model="recurringBooking.repeatUntil"
                            label="Wiederholen bis"
                            prepend-icon="mdi-calendar"
                            bg-color="accent"
                            variant="filled"
                            readonly
                            hide-details
                            v-bind="props"
                            @click:prepend-icon="repeatUntilMenu = true"
                            :rules="validationRules.required"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="recurringBookingRepeatUntilTemp"
                          scrollable
                          hide-title
                          :min="dateFrom"
                          :max="maxRepeatUntil"
                          :first-day-of-week="1"
                          @update:model-value="
                            (v) => {
                              recurringBookingRepeatUntilTemp = v;
                              repeatUntilMenu = false;
                            }
                          "
                        >
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </template>
              </template>
              <v-row class="mt-5">
                <v-col>
                  <p class="text-uppercase">
                    <strong>Personenbezogene Daten</strong>
                  </p>
                </v-col>
              </v-row>
              <v-divider class="mb-5" />
              <v-row>
                <v-col>
                  <v-text-field
                    bg-color="accent"
                    variant="filled"
                    hide-details
                    label="Name"
                    required
                    v-model="selectedBooking.name"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    bg-color="accent"
                    variant="filled"
                    hide-details
                    label="Firma"
                    v-model="selectedBooking.company"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    bg-color="accent"
                    variant="filled"
                    label="E-Mail*"
                    required
                    :rules="validationRules.mail"
                    v-model="selectedBooking.mail"
                    :validate-on="true ? 'blur' : undefined"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    bg-color="accent"
                    variant="filled"
                    label="Telefon"
                    v-model="selectedBooking.phone"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    bg-color="accent"
                    variant="filled"
                    hide-details
                    label="Straße"
                    v-model="selectedBooking.street"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    bg-color="accent"
                    variant="filled"
                    hide-details
                    label="PLZ"
                    required
                    v-model="selectedBooking.zipCode"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    bg-color="accent"
                    variant="filled"
                    hide-details
                    label="Stadt"
                    required
                    v-model="selectedBooking.location"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-5">
                <v-col>
                  <v-textarea
                    bg-color="accent"
                    variant="filled"
                    hide-details
                    label="Bemerkung"
                    required
                    v-model="selectedBooking.comment"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              class="mb-5"
              color="primary"
              variant="flat"
              @click="submitChanges"
              :loading="inProgress"
            >
              Speichern
            </v-btn>
            <v-btn class="mb-5 mr-5" variant="outlined" @click="closeDialog">
              Abbrechen
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ApiBookingService from "@/services/api/ApiBookingService";
import { mapActions } from "vuex";
import { nextTick } from "vue";
import ToastService from "@/services/ToastService";
import ApiTenantService from "@/services/api/ApiTenantService";
import Matomo from "@/utils/Matomo";

export default {
  name: "BookingEdit",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    booking: {
      type: Object,
      required: true,
    },
    bookables: {
      type: Array,
      required: true,
    },
    workflow: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      valid: true,
      inProgress: false,
      test: null,
      addBookableValue: null,

      dateFromModal: false,
      dateToModal: false,
      dateFromTemp: null,
      dateToTemp: null,

      timeFromModal: false,
      timeToModal: false,
      timeFromTemp: null,
      timeToTemp: null,

      repeatUntilMenu: false,

      bookableId_temp: null,

      activePaymentApps: [],

      allowRecurringBookings: false,
      days: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      repeatUnitTypes: [
        { title: "Tag", value: "day" },
        { title: "Woche", value: "week" },
        { title: "Monat", value: "month" },
      ],
      recurringBookingRepeatUntilTemp: null,
      recurringBooking: {
        repeatEvery: null,
        repeatUnit: "day",
        repeatOnWeekdays: [],
        monthRepeatBy: "date",
        repeatUntil: null,
        isAvailableOnly: true, // there are no conflicts while manually creating recurring bookings
      },

      events: [],
      validationRules: {
        priceRules: [
          (v) => parseFloat(v) >= 0 || "Preis darf nicht negativ sein",
        ],
        bookableItemRequired: [
          () =>
            (this.bookableItems && this.bookableItems.length !== 0) ||
            "Mindestens ein Buchungsobjekt ist erforderlich.",
        ],
        mail: [
          (v) => !!v || "E-Mail ist erforderlich",
          (v) =>
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "E-Mail muss gültig sein",
        ],
        required: [(v) => !!v || "Dieses Feld ist erforderlich"],
      },
      paymentMethod: [
        {
          type: "CASH",
          title: "Bar",
        },
        {
          type: "TRANSFER",
          title: "Überweisung",
        },
        {
          type: "CREDIT_CARD",
          title: "Kreditkarte",
        },
        {
          type: "DEBIT_CARD",
          title: "EC-Karte",
        },
        {
          type: "PAYPAL",
          title: "PayPal",
        },
        {
          type: "OTHER",
          title: "Sonstiges",
        },
        {
          type: "GIROPAY",
          title: "Giropay",
        },
        {
          type: "APPLE_PAY",
          title: "Apple Pay",
        },
        {
          type: "GOOGLE_PAY",
          title: "Google Pay",
        },
        {
          type: "UNKNOWN",
          title: "Unbekannt",
        },
        {
          type: "EPS",
          title: "EPS",
        },
        {
          type: "IDEAL",
          title: "iDEAL",
        },
        {
          type: "MAESTRO",
          title: "Maestro",
        },
        {
          type: "PAYDIRECT",
          title: "paydirekt",
        },
        {
          type: "SOFORT",
          title: "SOFORT-Überweisung",
        },
        {
          type: "BLUECODE",
          title: "Bluecode",
        },
      ],
    };
  },
  computed: {
    selectedBookingIsSet() {
      return !_.isNil(this.selectedBooking?._populated);
    },
    openDialog: {
      get() {
        return this.open;
      },
    },
    selectedBooking: {
      get() {
        return this.booking;
      },
    },
    dateFrom: {
      get() {
        if (!this.selectedBooking.timeBegin) {
          return this.formatDate(new Date());
        }
        return this.formatDate(new Date(this.selectedBooking.timeBegin));
      },
      set(val) {
        this.selectedBooking.timeBegin = new Date(
          val + " " + this.timeFrom
        ).getTime();
      },
    },
    dateTo: {
      get() {
        if (!this.selectedBooking.timeEnd) {
          return this.formatDate(new Date());
        }
        return this.formatDate(new Date(this.selectedBooking.timeEnd));
      },
      set(val) {
        this.selectedBooking.timeEnd = new Date(
          val + " " + this.timeTo
        ).getTime();
      },
    },
    timeFrom: {
      get() {
        if (!this.selectedBooking.timeBegin) {
          return this.formatTime(new Date());
        }
        return this.formatTime(new Date(this.selectedBooking.timeBegin));
      },
      set(val) {
        this.selectedBooking.timeBegin = new Date(
          this.dateFrom + " " + val
        ).getTime();
      },
    },
    timeTo: {
      get() {
        if (!this.selectedBooking.timeEnd) {
          return this.formatTime(new Date());
        }
        return this.formatTime(new Date(this.selectedBooking.timeEnd));
      },
      set(val) {
        this.selectedBooking.timeEnd = new Date(
          this.dateTo + " " + val
        ).getTime();
      },
    },
    bookableItems: {
      get() {
        return this.selectedBooking.bookableItems;
      },
      set(val) {
        this.bookableItems = val;
      },
    },
    allowRecurringBookingsCreation() {
      if (!this.bookableItems?.length) return false;
      return this.bookableItems?.every(
        (bookable) => bookable._bookableUsed.allowRecurringBooking
      );
    },
    maxRepeatUntil() {
      const d = new Date();
      d.setFullYear(d.getFullYear() + 1);
      return d.toISOString().split("T")[0];
    },
    monthlyRepeatOptions() {
      if (!this.dateFrom) return [];

      const dateBegin = new Date(this.dateFrom).getTime();
      const date = new Date(dateBegin);
      const day = date.getDate();
      const weekday = date.getDay();
      const month = date.getMonth();
      const year = date.getFullYear();

      const weekOfMonth = Math.floor((day - 1) / 7) + 1;
      const lastWeekday = new Date(year, month + 1, 0).getDate() - day < 7;

      const weekdayNames = [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag",
      ];

      return [
        {
          title: `Am ${day}. Tag des Monats`,
          value: "date",
        },
        {
          title: lastWeekday
            ? `Am letzten ${weekdayNames[weekday]} des Monats`
            : `Am ${weekOfMonth}. ${weekdayNames[weekday]} des Monats`,
          value: "weekday",
        },
      ];
    },
  },
  watch: {
    openDialog(val) {
      if (val) {
        nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        });
      }
    },
    dateFrom: function () {
      this.getEvents();
    },
    dateFromModal: function () {
      this.dateFromTemp = new Date(this.dateFrom);
    },
    timeFromModal: function () {
      this.timeFromTemp = this.timeFrom;
    },
    dateToModal: function () {
      this.dateToTemp = new Date(this.dateTo);
    },
    timeToModal: function () {
      this.timeToTemp = this.timeTo;
    },
    timeFrom: function () {
      this.getEvents();
    },

    dateTo: function () {
      this.getEvents();
    },

    timeTo: function () {
      this.getEvents();
    },
    recurringBookingRepeatUntilTemp: function () {
      this.recurringBooking.repeatUntil = this.recurringBookingRepeatUntilTemp;
    },
    booking: {
      handler() {
        this.fetchActivePaymentApps();
      },
      immediate: true, // run once when component is mounted
    },
  },
  methods: {
    ...mapActions({
      addToast: "toasts/add",
    }),
    getPriceCategory(bookableId, field) {
      const bookableItem = this.bookableItems.find(
        (b) => b.bookableId === bookableId
      );
      const { priceCategories, priceType } = bookableItem._bookableUsed;

      if (priceCategories.length === 1) {
        if (field) {
          return priceCategories[0][field];
        }
        return priceCategories[0];
      }

      const bookingDurationInMinutes = this.getBookingDuration();

      let valueToCheck;
      switch (priceType) {
        case "per-hour":
          valueToCheck = bookingDurationInMinutes / 60;
          break;
        case "per-day":
          valueToCheck = bookingDurationInMinutes / 60 / 24;
          break;
        case "per-item":
          valueToCheck = bookableItem.amount;
          break;
        case "per-square-meter":
          valueToCheck = bookableItem.amount;
          break;
        default:
          return null;
      }

      const category =
        priceCategories.find(({ interval }) => {
          const { start, end } = interval;
          return (
            (start === null || start <= valueToCheck) &&
            (end === null || end >= valueToCheck)
          );
        }) || priceCategories[0];

      if (field) {
        return category[field];
      }
      return category;
    },
    getBookingDuration() {
      if (
        !this.selectedBooking ||
        !this.selectedBooking.timeEnd ||
        !this.selectedBooking.timeBegin
      ) {
        return 0;
      }
      return Math.round(
        (this.selectedBooking.timeEnd - this.selectedBooking.timeBegin) / 60000
      );
    },
    updatePriceCategory(bookableId, newPrice) {
      const category = this.getPriceCategory(bookableId);
      category.priceEur = Number(newPrice);
    },
    updateFixedPrice(bookableId, value) {
      const category = this.getPriceCategory(bookableId);
      category.fixedPrice = !!value;
    },
    remove(item) {
      // remove item from  selectedBooking.bookableIds
      this.selectedBooking.bookableIds =
        this.selectedBooking.bookableIds.filter(
          (bookableId) => bookableId !== item.id
        );
    },
    closeDialog() {
      this.$emit("close");
    },
    async submitChanges() {
      const result = await this.$refs.form.validate();
      if (result.valid) {
        if (!this.selectedBooking._id) {
          this.inProgress = true;
          const payload = {
            ...this.selectedBooking,
          };
          if (this.recurringBooking?.repeatEvery) {
            payload.recurringBooking = this.recurringBooking;
          }
          await ApiBookingService.storeBooking(payload)
            .then((response) => {
              this.inProgress = false;
              Matomo.trackEvent([
                "trackEvent",
                "Booking",
                "Created",
                "Admin",
                response.data?.priceEur || 0,
              ]);
              this.closeDialog();
            })
            .catch(() => {
              this.addToast(
                ToastService.createToast("booking.create.error", "error")
              );
              this.inProgress = false;
            });
        } else {
          this.inProgress = true;
          delete this.selectedBooking._id;
          await ApiBookingService.storeBooking(this.selectedBooking)
            .then()
            .catch(() => {
              this.addToast(
                ToastService.createToast("booking.edit.error", "error")
              );
              this.inProgress = false;
            });
          this.inProgress = false;
          this.closeDialog();
        }
      } else {
        // reset validation after 4 seconds
        setTimeout(() => {
          this.$refs.form?.resetValidation();
        }, 4000);
      }
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    formatDate(date) {
      if (date !== "Invalid Date") {
        return [
          date.getFullYear(),
          this.padTo2Digits(date.getMonth() + 1),
          this.padTo2Digits(date.getDate()),
        ].join("-");
      } else {
        return null;
      }
    },
    formatTime(date) {
      if (date !== "Invalid Date") {
        return [
          this.padTo2Digits(date.getHours()),
          this.padTo2Digits(date.getMinutes()),
        ].join(":");
      } else {
        return "00:00";
      }
    },
    formatDateTime: function (d) {
      return Date.parse(d);
    },
    getEvents() {
      ApiBookingService.getPublicBookings(this.tenant)
        .then((response) => {
          const bookings = response.data;
          const events = bookings
            .filter((b) => b.bookableId === this.bookableId)
            .map((b) => {
              return {
                name: "Gebucht",
                start: this.formatDateTime(new Date(b.timeBegin)),
                end: this.formatDateTime(new Date(b.timeEnd)),
                color: "grey",
                timed: true,
              };
            });

          if (this.selectedBooking.timeBegin && this.selectedBooking.timeEnd) {
            events.push({
              name: "Ihr Wunschtermin",
              start: this.formatDateTime(
                new Date(this.selectedBooking.timeBegin)
              ),
              end: this.formatDateTime(new Date(this.selectedBooking.timeEnd)),
              color: "red",
              timed: true,
            });
          }

          this.events = events;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    increaseAmount(bookableItem) {
      bookableItem.amount++;
    },
    decreaseAmount(bookableItem) {
      if (bookableItem.amount > 1) {
        bookableItem.amount--;
      } else {
        this.selectedBooking.bookableItems =
          this.selectedBooking.bookableItems.filter(
            (b) => b.bookableId !== bookableItem.bookableId
          );
      }
    },
    addBookable() {
      const existing = this.selectedBooking.bookableItems.find(
        (b) => b.bookableId === this.addBookableValue
      );

      if (existing) {
        existing.amount++;
      } else {
        const bookable = this.bookables.find(
          (b) => b.id === this.addBookableValue
        );

        this.selectedBooking.bookableItems.push({
          bookableId: bookable.id,
          amount: 1,
          _bookableUsed: bookable,
        });
      }

      this.addBookableValue = null;
      this.$refs.bookableAutocomplete?.resetValidation();
    },
    removeBookingTimes() {
      this.selectedBooking.timeBegin = null;
      this.selectedBooking.timeEnd = null;
    },
    toggleDay(dayIndex) {
      const idx = this.recurringBooking.repeatOnWeekdays.indexOf(dayIndex);
      if (idx > -1) {
        this.recurringBooking.repeatOnWeekdays.splice(idx, 1);
      } else {
        this.recurringBooking.repeatOnWeekdays.push(dayIndex);
      }
    },
    async fetchActivePaymentApps() {
      try {
        const response = await ApiTenantService.getTenantActivePaymentApps(
          this.booking.tenantId
        );
        this.activePaymentApps = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    isTimeRelated(bookable, isFixedPrice) {
      if (isFixedPrice) {
        return "";
      }

      switch (bookable.priceType) {
        case "per-item":
          return "pro Stück";
        case "per-hour":
          return "pro Stunde";
        case "per-day":
          return "pro Tag";
        case "per-square-meter":
          return "pro m²";
        default:
          return "pro Stück";
      }
    },
  },
  mounted() {
    if (this.selectedBooking._id) {
      this.getEvents();
    }
  },
};
</script>

<style scoped>
.day-btn {
  height: 48px !important;
  width: 48px !important;
  padding: 0px;
  border: 1px solid #ccc;
}
.selected-day {
  background-color: #0099db;
  color: white;
}
</style>
